<template>
    <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.04 0H2.56C1.152 0 0.0128 1.152 0.0128 2.56L0 17.92C0 19.328 1.152 20.48 2.56 20.48H23.04C24.448 20.48 25.6 19.328 25.6 17.92V2.56C25.6 1.152 24.448 0 23.04 0ZM23.04 5.12L12.8 11.52L2.56 5.12V2.56L12.8 8.96L23.04 2.56V5.12Z"
            fill="currentColor" />
    </svg>
</template>
<script>
export default {
    name: "MailIcon",
};
</script>
<style scoped></style>
